/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

import Alerts from "./Alerts";
import BSGrid from "react-bootstrap/Grid";
import PropTypes from "prop-types";
import React, {Component} from "react";

export default class Content extends Component {
  static propTypes = {
    auctionEx: PropTypes.shape({
      alerts: PropTypes.shape({
        errors: PropTypes.array,
        info: PropTypes.array,
        success: PropTypes.array,
        warning: PropTypes.array,
      }).isRequired,
    }).isRequired,

    components: PropTypes.oneOfType([
      PropTypes.shape({
        Content: PropTypes.func.isRequired,
      }),
      PropTypes.shape({
        Body: PropTypes.func,
        Breadcrumb: PropTypes.func,
        Header: PropTypes.func,
      }),
    ]).isRequired,
  };

  render() {
    const components = this.props.components;
    const alertsComponent = (
      <Alerts
        className="notifications"
        {...this.props.auctionEx.alerts}
      />
    );
    const componentsProps = this.props.auctionEx;

    if (this.props.components.Content) {
      // If users want more flexibility, they can override the `Content`
      // component.
      const OverrideComponent = this.props.components.Content;

      return (
        <OverrideComponent
          {...componentsProps}
          alerts={alertsComponent}
          auctionEx={componentsProps}
          components={components}
        />
      );
    }

    // Case for most entry points.
    return (
      <BSGrid>
        {components.Breadcrumb ? (
          <components.Breadcrumb {...componentsProps} />
        ) : null}
        {components.Header ? (
          <components.Header {...componentsProps} />
        ) : null}
        {alertsComponent}
        {components.Body ? (
          <components.Body {...componentsProps} />
        ) : null}
      </BSGrid>
    );
  }
}



// WEBPACK FOOTER //
// ../render/components/Content.jsx